<template>
  <div id="results">
    {{ getGrade() }}
    {{ getOwnGrade() }}
    {{ getSumPerChapter() }}
    {{ smoothScroll() }}
    <header>
      <a href="/">
        <img class="logo logo-desktop" src="./../assets/img/logos/logo-driessen-desktop.svg" alt="Driessen Logo">
        <img class="logo logo-mobile" src="./../assets/img/logos/logo-driessen-mobile.svg" alt="Driessen Logo">
      </a>
    </header>
    <main>
      <h1>Test je werkgeluk quiz</h1>
      <div class="user user-results">
        <div class="left results" v-bind:class="classResults" v-if="this.grade != null">
          <div class="left-contents">
            <div class="label-white-large fade-in">Volgens deze test is jouw werkgelukcijfer een</div>
            <div class="response heartBeat animated"><div class="emoticon" v-bind:class="emotionsResults"></div>{{ grade }}</div>
            <div class="speech-bubble explanation flipInX animated">
              <h3>Deze score is gebaseerd op 4 factoren:</h3>
              <ul class="checklist checklist--green">
                <li>je relatie met collega's</li>
                <li>je competenties</li>
                <li>je vrijheid in je werk</li>
                <li>je manier van mensen gelukkig maken</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <nav class="menu-tips">
        <ul>
          <li><a href="#tip-1" v-bind:class="{ 'active': tipActive === '#tip-1' }"
                 v-on:click="mouseClick('#tip-1')">Tips
            inleiding</a></li>
          <li><a href="#tip-2" v-bind:class="{ 'active': tipActive === '#tip-2' }"
                 v-on:click="mouseClick('#tip-2')">Tip
            Verbondenheid</a></li>
          <li><a href="#tip-3" v-bind:class="{ 'active': tipActive === '#tip-3' }"
                 v-on:click="mouseClick('#tip-3')">Tip
            Competentie</a></li>
          <li><a href="#tip-4" v-bind:class="{ 'active': tipActive === '#tip-4' }"
                 v-on:click="mouseClick('#tip-4')">Tip
            Autonomie</a></li>
          <li><a href="#tip-5" v-bind:class="{ 'active': tipActive === '#tip-5' }"
                 v-on:click="mouseClick('#tip-5')">Tip
            Maatschappelijke relevantie</a></li>
          <li><a href="#tip-6" v-bind:class="{ 'active': tipActive === '#tip-6' }"
                 v-on:click="mouseClick('#tip-6')">Tips
            Afsluiting</a></li>
        </ul>
      </nav>
      <div class="right tips">
        <div class="tips">
          <div class="tip" id="tip-1">
            <p class="explanation">De score van de werkgeluktest is gebaseerd op 4 factoren die invloed hebben op je werkgeluk; de relatie
              met je collega's, hoe goed jij je competenties kan benutten in je functie, de vrijheid die je hebt om te
              doen wat je leuk vindt en de maatschappelijke relevantie die je werk heeft.</p>
            <p>Zelf beoordeelde jij jouw werkgeluk met een <strong>{{ ownGrade }}</strong>. Bekijk hier per factor wat jij kunt doen om jouw werkgeluk te vergroten.</p>
            <div class="to-tip">
              <div class="label-red">Bekijk je tips</div>
              <a href="#tip-2" class="button down" v-on:click="mouseClick('#tip-2')">Volgende
                tip</a>
            </div>
          </div>
          <div class="tip" id="tip-2">
            <h2>{{ tipTitleSolidarity }}</h2>
            <p v-html="tipSolidarity"></p>
            <p v-html="tipLinkTextSolidarity"></p>
            <div class="to-tip">
              <div class="label-red">Volgende tip</div>
              <a href="#tip-3" class="button down" v-on:click="mouseClick('#tip-3')">Volgende
                tip</a>
            </div>
          </div>
          <div class="tip" id="tip-3">
            <h2>{{ tipTitleCompetence }}</h2>
            <p v-html="tipCompetence"></p>
            <p v-html="tipLinkTextCompetence"></p>
            <div class="to-tip">
              <div class="label-red">Volgende tip</div>
              <a href="#tip-4" class="button down" v-on:click="mouseClick('#tip-4')">Volgende
                tip</a>
            </div>
          </div>
          <div class="tip" id="tip-4">
            <h2>{{ tipTitleAutonomy }}</h2>
            <p v-html="tipAutonomy"></p>
            <p v-html="tipLinkTextAutonomy"></p>
            <div class="to-tip">
              <div class="label-red">Volgende tip</div>
              <a href="#tip-5" class="button down" v-on:click="mouseClick('#tip-5')">Volgende
                tip</a>
            </div>
          </div>
          <div class="tip" id="tip-5">
            <h2>{{ tipTitleSocial }}</h2>
            <p v-html="tipSocial"></p>
            <p v-html="tipLinkTextSocial"></p>
            <div class="to-tip">
              <div class="label-red">Volgende tip</div>
              <a href="#tip-6" class="button down" v-on:click="mouseClick('#tip-6')">Volgende
                tip</a>
            </div>
          </div>
          <div class="tip" id="tip-6">
            <h2>Vind je werkgeluk bij Driessen</h2>
            <p>Bij Driessen vind je werk in de publieke sector. Bij ons kun je terecht voor functies in de overheid,
              het onderwijs, zorg & welzijn en de cultuursector. Met je talent kun jij anderen helpen, iets leren
              of zorg je voor anderen. Werk dat de maatschappij mooier en gelukkiger maakt.</p>
            <p>Veel werkgeluk toegewenst!</p>
            <div>
              <a class="button button--margin" href="https://www.driessen.nl/vacatures?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">bekijk onze vacatures</a>
            </div>
            <div class="button-container">
              of &nbsp;&nbsp;<a class="button" href="https://www.driessen.nl/content/werkgeluktest-mijn-driessen?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">schrijf je gratis in</a>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
  import getGrade from '../mixins/getGrade.js';
  import database from '../components/firebaseInit'

  // A reference to the users collection.
  const users = database.collection('users');


  export default {
    name: 'Results',
    mixins: [getGrade],
    data() {
      return {
        grade: null,
        ownGrade: null,
        uid: this.$route.params.uid,
        tipActive: '#tip-1',
        tipTitleSolidarity: null,
        tipSolidarity: null,
        tipLinkTextSolidarity: null,
        tipTitleCompetence: null,
        tipCompetence: null,
        tipLinkTextCompetence: null,
        tipTitleAutonomy: null,
        tipAutonomy: null,
        tipLinkTextAutonomy: null,
        tipTitleSocial: null,
        tipSocial: null,
        tipLinkTextSocial: null,
      }
    },
    computed: {
      classResults: function () {
        return {
          'results-color--red': this.grade < 6,
          'results-color--orange': this.grade >= 6 && this.grade < 7,
          'results-color--green': this.grade >= 7
        }
      },
      emotionsResults: function () {
        return {
          'emoticon--totally-agree': this.grade > 8,
          'emoticon--agree': this.grade >= 6 && this.grade <= 8,
          'emoticon--neutral': this.grade >= 5 && this.grade < 6,
          'emoticon--disagree': this.grade >= 3 && this.grade < 5,
          'emoticon--totally-disagree': this.grade >= 1 && this.grade < 3,
        }
      }
    },
    methods: {
      getOwnGrade: function () {
        const docRef = users.doc(this.uid);
        docRef.get().then((documentSnapshot) => {
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();
            this.ownGrade = data.happiness_job;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        }).catch(function (error) {
          console.log("Error getting document:", error);
        });
      },
      smoothScroll: function () {
        Array.from(document.querySelectorAll('a[href^="#"]')).forEach(anchor => {
          anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
            });
          });
        });
      },
      onScroll: function () {
        let tip = document.querySelectorAll(".tip");
        let tips = {};
        let i = 0;

        Array.prototype.forEach.call(tip, function (e) {
          tips[e.id] = e.offsetTop;
        });

        let scrolledDiv = document.querySelector(".right");

        scrolledDiv.onscroll = function () {
          let scrollPosition = scrolledDiv.scrollTop;

          for (i in tips) {
            if (tips[i] <= scrollPosition) {
              document.querySelector('.active').setAttribute('class', ' ');
              document.querySelector('a[href*=' + i + ']').setAttribute('class', 'active');
            }
          }
        };
      },
      mouseClick: function (tipId) {
        setTimeout(() => this.tipActive = tipId, 750);
      },
      getSumPerChapter: function () {
        const docRef = users.doc(this.uid);
        docRef.get().then((documentSnapshot) => {
          if (documentSnapshot.exists) {
            const data = documentSnapshot.data();
            // Solidarity.
            let part = eval(data.answers.part);
            let important = eval(data.answers.important);
            let friends = eval(data.answers.friends);
            let understand = eval(data.answers.understand);
            let sumSolidarity = part + important + friends + understand;
            // Competence.
            let control = eval(data.answers.control);
            let performance = eval(data.answers.performance);
            let doing_well = eval(data.answers.doing_well);
            let hardest_tasks = eval(data.answers.hardest_tasks);
            let sumCompetence = control + performance + doing_well + hardest_tasks;
            // Autonomy.
            let expression = eval(data.answers.expression);
            let myself = eval(data.answers.myself);
            let want = eval(data.answers.want);
            let best = eval(data.answers.best);
            let sumAutonomy = expression + myself + want + best;
            // Social.
            let meaning = eval(data.answers.meaning);
            let matters = eval(data.answers.matters);
            let contribute = eval(data.answers.contribute);
            let society = eval(data.answers.society);
            let sumSocial = meaning + matters + contribute + society;

            // Check for invalid sum first.
            if (typeof sumSolidarity !== 'number' || sumSolidarity < 0 || sumSolidarity > 80) {
              console.log("Invalid sum");
            }
            if (typeof sumCompetence !== 'number' || sumCompetence < 0 || sumCompetence > 80) {
              console.log("Invalid sum");
            }
            if (typeof sumAutonomy !== 'number' || sumAutonomy < 0 || sumAutonomy > 80) {
              console.log("Invalid sum");
            }
            if (typeof sumSocial !== 'number' || sumSocial < 0 || sumSocial > 80) {
              console.log("Invalid sum");
            }

            // Relate sum to a tip.
            let tipTitleSolidarity = "";
            let tipSolidarity = "";
            let tipLinkTextSolidarity = "";

            switch (true) {
                // 0 - 5.
              case sumSolidarity <= 5:
                tipTitleSolidarity = 'Collega’s, je bent ze liever kwijt dan rijk';
                tipSolidarity = 'Op het onderdeel <strong>Verbondenheid</strong> scoor jij laag. Oei, jouw collega’s zijn duidelijk niet je beste vrienden. Misschien ligt het eraan dat het gewoon niet jouw type mensen zijn, misschien erger je je dagelijks groen en geel of misschien ben je gewoon tevreden met de situatie zoals die is. Toch draagt verbondenheid met de organisatie waar je werkt en je collega’s bij aan jouw werkgeluk. Om nu meteen beste vrienden te worden met je collega’s is misschien wat overdreven, maar investeren in de relatie met je collega’s brengt zeker voordelen met zich mee voor jouw werkgeluk.';
                tipLinkTextSolidarity = 'In dit <a href="https://www.driessen.nl/samenslim/mentaal-vitaal-door-steun-van-collegas?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">artikel</a> lees je meer over wat een goede band met collega’s jou kan opleveren.';
                break;
                // 6 - 10.
              case sumSolidarity <= 10:
                tipTitleSolidarity = 'Beter een verre vriend dan een goede collega?';
                tipSolidarity = 'Op het onderdeel <strong>Verbondenheid</strong> scoor jij gemiddeld. De band met je collega’s kan wel wat verbetering gebruiken. Misschien zijn het niet jouw soort mensen of erger je je soms groen en geel aan iemand? Verbondenheid met de organisatie waar je werkt en de directe collega’s om je heen dragen bij aan werkgeluk. Belangrijk dus om de band te verstevigen. Een groot deel van de dag beleef je tenslotte op het werk, waardoor je je collega’s misschien zelfs nog wel meer ziet dan je eigen partner en vrienden.';
                tipLinkTextSolidarity = 'In dit <a href="https://www.driessen.nl/samenslim/beter-een-goede-collega-dan-een-verre-vriend?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">artikel</a> vind je tips om de band met je collega’s te versterken en eventuele (kleine) irritaties aan de kant te zetten.';
                break;
                // 11 - 16.
              case sumSolidarity <= 16:
                tipTitleSolidarity = 'Collega’s? Voor jou zijn het vrienden';
                tipSolidarity = 'Op het onderdeel <strong>Verbondenheid</strong> scoor je hoog. Bij jouw collega’s ben je helemaal op je plek en kun je helemaal jezelf zijn. Een hoge verbondenheid met de organisatie waar je werkt en de directe collega’s om je heen, dragen bij aan jouw werkgeluk. Belangrijk dus om de band met je collega’s goed te houden. Een groot deel van de dag beleef je tenslotte met hun. Je ziet ze misschien zelfs nog wel meer dan je eigen partner, gezin en/of vrienden.';
                tipLinkTextSolidarity = 'Doe <a href="https://www.driessen.nl/samenslim/de-10-collegas-die-je-niet-kunt-missen?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> de ‘Collega’s die je niet kunt missen’-BINGO.';
                break;
            }

            this.tipTitleSolidarity = tipTitleSolidarity;
            this.tipSolidarity = tipSolidarity;
            this.tipLinkTextSolidarity = tipLinkTextSolidarity;

            // Relate sum to a tip.
            let tipTitleCompetence = "";
            let tipCompetence = "";
            let tipLinkTextCompetence = "";

            console.log(sumCompetence);

            switch (true) {
                // 0 - 5.
              case sumCompetence <= 5:
                tipTitleCompetence = 'Help, de sleur slaat toe';
                tipCompetence = 'Op het onderdeel <strong>Competentie</strong> scoor je laag. Dit vraagt om aandacht. Je werkgeluk wordt voor een groot deel bepaald door hoe jij je kwaliteiten in je werk kunt benutten. Helemaal op je plek zit je dus waarschijnlijk niet (meer) in je huidige functie. Onderzoek waar jouw talenten en drijfveren liggen, maak het bespreekbaar bij je leidinggevende en onderneem actie. Het wordt tijd dat jij weer plezier krijgt in je werk!';
                tipLinkTextCompetence = 'Lees <a href="https://www.driessen.nl/samenslim/wat-als-de-sleur-toeslaat?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer over hoe je de sleur in je werk kunt aanpakken.';
                break;
                // 6 - 10.
              case sumCompetence <= 10:
                tipTitleCompetence = 'Het glas is half vol';
                tipCompetence = 'Op het onderdeel <strong>Competentie</strong> scoor je gemiddeld. Jij en je werk hebben af en toe een haat-liefdeverhouding. Het ene moment kun je er je ei helemaal in kwijt, het andere moment ben je aan het worstelen met dat wat je moet doen. Probeer je weg te vinden, praat met je leidinggevende over wat je leuk vindt om te doen en waar je moeite mee hebt en achterhaal wat jouw drijfveren zijn. Want het benutten van je talent en competenties in je werk draagt bij aan jouw werkgeluk.';
                tipLinkTextCompetence = 'Wat zou het toch gaaf zijn als je heel de dag kon doen wat je leuk vindt, het kan! Lees <a href="https://www.driessen.nl/samenslim/als-doet-leuk-vindt-hoef-nooit-meer-werken?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer.';
                break;
                // 11 - 16.
              case sumCompetence <= 16:
                tipTitleCompetence = 'Jij bent de beste versie van jezelf in jouw werk!';
                tipCompetence = 'Op het onderdeel <strong>Competentie</strong> scoor je hoog. In jouw werk ben je helemaal in je element. Je kunt er je kwaliteiten in kwijt en schittert van zelfvertrouwen. Kortom, jouw functie is voor jou gemaakt. Je talenten kwijt kunnen in je werk draagt in hoge mate bij aan het ervaren van werkgeluk. Ga dus vooral zo door, maar blijf jezelf wel ontwikkelen en ga uitdagingen aan, want een baan voor het leven bestaat niet meer.';
                tipLinkTextCompetence = 'In dit <a href="https://www.driessen.nl/samenslim/over-10-jaar?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">artikel</a> meer over hoe jij je kunt voorbereiden op de toekomst.';
                break;
            }

            this.tipTitleCompetence = tipTitleCompetence;
            this.tipCompetence = tipCompetence;
            this.tipLinkTextCompetence = tipLinkTextCompetence;

            // Relate sum to a tip.
            let tipTitleAutonomy = "";
            let tipAutonomy = "";
            let tipLinkTextAutonomy = "";

            switch (true) {
                // 0 - 5.
              case sumAutonomy <= 5:
                tipTitleAutonomy = 'Neem de regie in eigen hand';
                tipAutonomy = 'Op het onderdeel <strong>Autonomie</strong> scoor je laag. Je voelt je beperkt in je doen en laten binnen je functie en ervaart niet de vrijheid om je mening te geven of je ideeën op tafel te gooien. Vrijheid in je werk zorgt voor meer productiviteit, een kleinere kans op een burn-out én het maakt je werkgelukkiger. Is er binnen jouw functie geen ruimte voor deze vrijheid en heb je hier wel behoefte aan? Ga het gesprek dan aan met je leidinggevende en kijk samen naar mogelijkheden binnen of desnoods buiten de organisatie om deze vrijheid alsnog te vinden.';
                tipLinkTextAutonomy = 'Vind je het moeilijk om het gesprek aan te gaan met je leidinggevende? Lees <a href="https://www.driessen.nl/samenslim/een-moeilijk-gesprek-aangaan-hoe-doe-je-dat?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> hoe je dit het beste kunt aanpakken.';
                break;
                // 6 - 10.
              case sumAutonomy <= 10:
                tipTitleAutonomy = 'Wat houdt je tegen?';
                tipAutonomy = 'Op het onderdeel <strong>Autonomie</strong> scoor je gemiddeld. Binnen bepaalde kaders voel je de vrijheid om je werk naar eigen inzicht in te vullen en je ideeën en bevindingen te delen met de organisatie. Toch houdt iets je tegen om helemaal jezelf te zijn en je eigen draai te geven aan je functie. Vrijheid in je werk zorgt voor meer productiviteit, een kleinere kans op een burn-out én het maakt je werkgelukkiger. Maak het bespreekbaar bij je leidinggevende en kijk samen naar de ruimte die er is en eventueel nog genomen kan worden.';
                tipLinkTextAutonomy = 'Vind je het moeilijk om dit gesprek aan te gaan? Lees <a href="https://www.driessen.nl/samenslim/een-moeilijk-gesprek-aangaan-hoe-doe-je-dat?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> hoe je dit het beste kunt aanpakken.';
                break;
                // 11 - 16.
              case sumAutonomy <= 16:
                tipTitleAutonomy = 'Zo vrij als een vogel';
                tipAutonomy = 'Op het onderdeel <strong>Autonomie</strong> scoor je hoog. In jouw werk krijg jij alle vrijheid om te doen wat je leuk vindt en waar je goed in bent. Daarnaast voel je alle vrijheid om je ideeën op tafel te gooien. Kortom, jij kunt helemaal jezelf zijn. Heel goed! Vrijheid in je werk zorgt voor meer productiviteit, een kleinere kans op een burn-out én het maakt je werkgelukkiger.';
                tipLinkTextAutonomy = 'Lees <a href="https://www.driessen.nl/samenslim/autonomie-als-basis-van-werkgeluk?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer over het positieve effect van autonomie op werkgeluk.';
                break;
            }

            this.tipTitleAutonomy = tipTitleAutonomy;
            this.tipAutonomy = tipAutonomy;
            this.tipLinkTextAutonomy = tipLinkTextAutonomy;

            // Relate sum to a tip.
            let tipTitleSocial = "";
            let tipSocial = "";
            let tipLinkTextSocial = "";

            switch (true) {
                // 0 - 5.
              case sumSocial <= 5:
                tipTitleSocial = 'Ben je niet betekenisvol? Of denk je het niet te zijn?';
                tipSocial = 'Op het onderdeel <strong>Maatschappelijke relevantie</strong> scoor je laag. Dat wil zeggen dat jij jouw werk niet als betekenisvol ervaart. Maar is het dat ook echt niet? Of zie jij alleen niet hoe betekenisvol jij bent? Wil je dit veranderen? Ontplooi dan binnen je werk maatschappelijk relevante initiatieven en activiteiten. Denk bijvoorbeeld aan het bijdragen aan een goed doel met je collega’s, het opknappen van een speeltuin als gezamenlijk teamuitje of het inzetten van je ervaring voor goede doelen of maatschappelijk werk, eventueel naast je reguliere baan. Je zult zien dat jij binnen de kortste keren meer werkgeluk ervaart.';
                tipLinkTextSocial = 'Lees <a href="https://www.driessen.nl/samenslim/werken-aan-betekenisvol-werk?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer hoe jij je werk betekenisvoller kan maken.';
                break;
                // 6 - 10.
              case sumSocial <= 10:
                tipTitleSocial = 'Go for it!';
                tipSocial = 'Op het onderdeel <strong>Maatschappelijke relevantie</strong> scoor je gemiddeld. Niet bij iedere functie is de maatschappelijke relevantie even goed tastbaar, maar wat je werk ook is, je bent altijd betekenisvol! Om meer betekenis te ervaren in je werk, is het belangrijk om je eigen professionele missie te bepalen. Dit is jouw leidraad in je werk. Het maakt duidelijk wie je bent, wat je wilt en waartoe je met je werk wilt bijdragen. Daarnaast geeft het antwoord op de vraag waarom je doet wat je doet in je werk.';
                tipLinkTextSocial = 'Lees <a href="https://www.driessen.nl/samenslim/werken-aan-betekenisvol-werk?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer over hoe jij je werk betekenisvoller kan maken.';
                break;
                // 11 - 16.
              case sumSocial <= 16:
                tipTitleSocial = 'Jij bent onmisbaar';
                tipSocial = 'Op het onderdeel <strong>Maatschappelijke relevantie</strong> scoor je hoog. Met jouw werk lever jij een onmisbare bijdrage aan de organisatie en/of de maatschappij. Kortom, jij bent betekenisvol! Werk dat als betekenisvol ervaren wordt, draagt bij aan positieve gevoelens als zelfvertrouwen, optimisme, hoop en werkgeluk. Dus blijf vooral doen waar je mee bezig bent en sta regelmatig even stil bij al het moois dat jij met jouw werk brengt.';
                tipLinkTextSocial = 'Benieuwd naar betekenisvolle beroepen? Lees <a href="https://www.driessen.nl/samenslim/heb-jij-een-betekenisvol-beroep?utm_source=test%20je%20werkgeluk&utm_medium=website" target="_blank" rel="noopener noreferrer">hier</a> meer.';
                break;
            }

            this.tipTitleSocial = tipTitleSocial;
            this.tipSocial = tipSocial;
            this.tipLinkTextSocial = tipLinkTextSocial;

          }
        });
      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.toggleBodyClass('addClass', 'results');
      this.onScroll();
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'results');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Results.vue